import { render, staticRenderFns } from "./aloituskeskustelu-card.vue?vue&type=template&id=3513d5f2&"
import script from "./aloituskeskustelu-card.vue?vue&type=script&lang=ts&"
export * from "./aloituskeskustelu-card.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports